export const SEND_EMAIL = "SEND_EMAIL";
export const SEND_SMS = "SEND_SMS ";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const GET_PROFILES = "GET_PROFILES";
export const OPEN_DRAWER = "OPEN_DRAWER";
export const CURRENT_PROFILE = "CURRENT_PROFILE";
